module.exports = "/_next/static/media/d1faaa8724f19ec30e3720b0fe08c29e.svg";